var collapsible_list_pair_rtlignore_default = {
  "container": "_8cA8M",
  "title": "V4LQu",
  "viewerContainer": "Guq8g",
  "titleContainer": "rl6gj",
  "content": "tq3Qu",
  "expandIcon": "HlN5X",
  "dndIcon": "WiXwz",
  "RTL": "Ixxh3",
  "LTR": "WVrW7",
  "itemContainer": "zk3CZ",
  "itemContainerViewer": "p8P-d",
  "mouseDown": "VtYH6",
  "innerEditor": "jAFZS",
  "item": "HF1c-",
  "floatingAddPluginMenuWrapper": "Qq4WR"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
